export const activeUser = (): string => "/users/me";

export const anonymousLogin = (): string => "/anonymous-users/login";

export const anonymousUsers = (): string => "/anonymous-users";

export const userLocation = (): string => "/users/me/location";

export const profileThemes = (): string => "/profile-themes";
